export {};

// Integration methods that Rappi Android app injects into the WebView
interface AndroidWebViewMethods {
  endCall: () => void;
  launchPayStore: (arg0: unknown) => void;
  onOrderSuccessful: (arg0: unknown, arg1: unknown) => void;
  onSyncContacts: () => void;
  onWebviewReady: () => void;
  openURL: (url: string) => void;
  requestAudioPermissions: () => void;
  requestCallPermissions: () => void;
  requestCameraPermissions: () => void;
  setStatusBarColor: (arg0: unknown, arg1: unknown) => void;
  startCheckout: (arg0: unknown) => void;
  startNativeCheckout: (arg0: unknown) => void;
  startNativeDefaultRefund: () => void;
}

// Integration methods that Rappi iOS app injects into the WebView
interface iOSWebViewMethods {
  messageHandlers?: {
    endCall: {
      postMessage: (arg0: '') => void;
    };
    launchPayStore: {
      postMessage: (arg0: unknown) => void;
    };
    onOrderSuccessful: {
      postMessage: (arg0: unknown, arg1: unknown) => void;
    };
    onSyncContacts: {
      postMessage: () => void;
    };
    onWebviewReady: {
      postMessage: () => void;
    };
    openURL: {
      postMessage: (url: string) => void;
    };
    requestAudioPermissions: {
      postMessage: () => void;
    };
    requestCallPermissions: {
      postMessage: () => void;
    };
    requestCameraPermissions: {
      postMessage: (arg0: unknown, arg1: unknown) => void;
    };
    setStatusBarColor: {
      postMessage: (arg0: unknown, arg1: unknown) => void;
    };
    startCheckout: {
      postMessage: (arg0: unknown) => void;
    };
    startNativeCheckout: {
      postMessage: (arg0: unknown) => void;
    };
    startNativeDefaultRefund: {
      postMessage: () => void;
    };
  };
}

declare global {
  interface Window {
    voximplant: {
      initAndCall: () => void;
      hangupCall: () => void;
    };

    Spreedly?: {
      on: (event: string, cb: () => void) => void;
      isLoaded: () => boolean;
      setStyle: (name: string, css: string) => void;
    };

    app?: AndroidWebViewMethods;
    appInterface?: AndroidWebViewMethods;
    webkit?: iOSWebViewMethods;
    webUploader?: any;
  }

  interface String {
    sanitize(): string;
    sanitizeExceptAccents(): string;
    capitalize(): string;
  }

  interface Number {
    toArray(): Array<number>;
  }

  interface Array<T> {
    first(): T;
    last(): T;
  }
}

Window.prototype.voximplant = {
  initAndCall: () => console.log('initAndCall'),
  hangupCall: () => console.log('hangupCall'),
};

String.prototype.sanitize = function () {
  return this.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/(,|\.|\/|-)/g, '')
    .replace(/ /g, '-');
};

String.prototype.sanitizeExceptAccents = function () {
  return this.replace(/[^\w\sÀ-ÖØ-öø-ÿ]/g, '');
};

String.prototype.capitalize = function () {
  return `${this[0].toUpperCase()}${this.substring(1).toLowerCase()}`;
};

Number.prototype.toArray = function () {
  const arr: number[] = [];
  for (let i = 1; i <= this; i++) {
    arr.push(i);
  }
  return arr;
};

Array.prototype.first = function () {
  return this[0];
};

Array.prototype.last = function () {
  return this[this.length - 1];
};
